import {
  g6IdToCollapsedGroupId,
  g6IdToCollapsedPairwiseNodeId,
  g6IdToHashableNodeId,
} from 'dashboard/components/GraphCanvasV2/G6Mapper';
import { Layer } from 'dashboard/components/GraphCanvasV2/layers/layer';
import CollapsedGroupTarget from 'dashboard/components/GraphCanvasV2/target/collapsed-group-target';
import CollapsedPairwiseNodeTarget from 'dashboard/components/GraphCanvasV2/target/collapsed-pairwise-node-target';
import NodeTarget from 'dashboard/components/GraphCanvasV2/target/node-target';

type CanvasNodeLayerTarget = NodeTarget | CollapsedGroupTarget | CollapsedPairwiseNodeTarget;

export default class CanvasNodeLayer extends Layer implements Iterable<CanvasNodeLayerTarget> {
  public [Symbol.iterator](): Iterator<CanvasNodeLayerTarget, null> {
    // Seed with relevant nodes
    let worldPoint;
    let g6Nodes;

    const targets: CanvasNodeLayerTarget[] = [];
    try {
      worldPoint = this.g6Wrapper.getPointByCanvas(this.canvasX, this.canvasY);
      g6Nodes = this.g6Wrapper.findNodesAtPosition(worldPoint.x, worldPoint.y);
      // g6 renders nodes such that newer nodes are drawn on top
      // g6Wrapper.findNodesAtPosition filters the list of nodes from g6.getNodes() which most likely is sorted
      // from oldest to newest
      // We reverse the list of g6Nodes to ensure we process events starting with the newer nodes first
      // this prevents events firing from a g6Node behind another g6Node
      for (const g6Node of g6Nodes.reverse()) {
        const nodeId = g6IdToHashableNodeId(g6Node.getID());
        if (nodeId) {
          targets.push(new NodeTarget(this.graphExplorer.getNodeById(nodeId)));
          continue;
        }
        const collapsedGroupId = g6IdToCollapsedGroupId(g6Node.getID());
        if (collapsedGroupId) {
          targets.push(
            new CollapsedGroupTarget(this.graphExplorer.getCollapsedGroupById(collapsedGroupId)),
          );
        }
        const collapsedPairwiseNodeId = g6IdToCollapsedPairwiseNodeId(g6Node.getID());
        if (collapsedPairwiseNodeId) {
          targets.push(
            new CollapsedPairwiseNodeTarget(
              this.graphExplorer.getCollapsedPairwiseNodeById(collapsedPairwiseNodeId),
            ),
          );
        }
      }
    } catch (e) {
      return {
        next: function () {
          return { value: null as null, done: true };
        },
      };
    }

    return {
      next: function () {
        const target = targets.shift();

        const result: IteratorResult<CanvasNodeLayerTarget, null> = target
          ? {
              value: target,
              done: false,
            }
          : {
              value: null,
              done: true,
            };

        return result;
      }.bind(this),
    };
  }
}
